import React, { Component } from "react";
import { Container } from "react-bootstrap";
import Footer from "../../components/Footer/Footer";
import ContactUsFooter from "../../components/ContactUsFooter/contactUsFooter";
import "./subProject.css";

export default class ProjectView extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  
  render() {
    return (

      <div>
      <Container className="mt-9">
        <img
          src="./assets/projects-logo/find-my-doc/logo.png"
          className="col-12 col-md-2 my-4 "
          alt=""
        />{" "}
        <h4 className="project-header">
          A dynamic medical booking management platform connecting patients with
          doctors and hospitals digitally.
        </h4>
        <p>
          At Ambrum, we transform ambitious ideas into digital realities
          blending smart software solutions with impactful marketing to shape
          the future of business.
        </p>
        <img
          src="./assets/projects-logo/find-my-doc/cover.png"
          className="w-100"
          alt=""
        />
        <div className="row m-4 justify-content-center">
            <h2 className="text-start">Project Overview</h2>
          <div className="col-lg-6 col-md-6 col-sm-12 col-12">
          
            <p className="text-justify">
              Find My Doc (FMD) is Ambrum’s flagship doctor channeling and
              healthcare management application built to simplify the healthcare
              experience for both patients and medical professionals. This
              mobile-first solution empowers users to book appointments anytime,
              track medical history, and access digital health services on the
              go—bringing healthcare into the digital age. Whether you’re a busy
              urban dweller or managing care for your entire family, FMD puts
              control and convenience right at your fingertips.
            </p>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-12 col-12">
            <img
              src="./assets/projects-logo/find-my-doc/img1.png"
              className="w-100"
              alt=""
            />
          </div>
        </div>
        <div className="row m-4 justify-content-center">
          <div className="col-5">
            <img
              src="./assets/projects-logo/find-my-doc/img2.png"
              className="w-100"
              alt=""
            />
          </div>
          <div className="col-6">
            <h2 className="text-start">Key Features We Engineered</h2>
            <ul className="text-justify">
              <li>
                <b>Doctor Booking System</b> - Real-time appointment booking
                with availability, specialization, and location filters.{" "}
              </li>
              <li>
                <b>Medical Record Tracking</b> - Patients can upload and access
                past prescriptions andmedical history.{" "}
              </li>
              <li>
                <b>Family & Group Accounts</b> - Manage bookings and records for
                the entire family under one app.{" "}
              </li>
              <li>
                <b>Smart Notifications -</b> Automated reminders for
                appointments and follow-ups.
              </li>
              <li>
                <b>Doctor-Focused Portal</b> - Separate app for doctors to
                manage calendar, view patient records, and update schedules.
              </li>
              <li>
                <b>Location-Based Search</b> - Easily find nearby medical
                centers and specialists.
              </li>
            </ul>
          </div>
        </div>
        <div>
          <h2>Why FMD Stands Out</h2>
          <p className="text-center">
            Unlike traditional booking systems, FMD isn’t just an appointment
            tool. It’s a fully-integrated healthcare platform offering
            intelligent syncing between doctors and patients, record keeping,
            and patient-centered design. It’s already transforming operations
            for private hospitals, independent clinics, and channeling centers
            across Sri Lanka.
          </p>
        </div>
        <div className="m-5">
          <h2>Tech Stack & Integration</h2>
          <div className="row justify-content-around">
            <div className="col-1">
              {" "}
              <img
                src="./assets/projects-logo/flutter.png"
                className="w-100"
                alt=""
              />
            </div>
            <div className="col-2">
              {" "}
              <img
                src="./assets/projects-logo/node.png"
                className="w-100"
                alt=""
              />
            </div>
            <div className="col-1">
              {" "}
              <img
                src="./assets/projects-logo/google-cloud.png"
                className="w-100"
                alt=""
              />
            </div>
            <div className="col-1">
              {" "}
              <img
                src="./assets/projects-logo/react.png"
                className="w-100"
                alt=""
              />
            </div>
            <div className="col-1">
              {" "}
              <img
                src="./assets/projects-logo/python.png"
                className="w-100"
                alt=""
              />
            </div>
            <div className="col-1">
              {" "}
              <img
                src="./assets/projects-logo/firebase.png"
                className="w-100"
                alt=""
              />
            </div>
          </div>
        </div>
        <div>
          <h2>Why Choose Ambrum for Healthcare Tech?</h2>
          <p className="text-center">
            We understand the complexities of medical ecosystems—from compliance
            and security to user comfort. At Ambrum, our cross-functional team
            specializes in crafting digital products that combine speed,
            security, and simplicity. From concept to launch, we ensure the
            solution meets both your business goals and user expectations.
          </p>
        </div>
        {/* <div className="container text-center">
          <div className="hero-text fw-700 my-5">
            LET’S{" "}
            <span className="hero-text-gradient">TRANSFORM THE FUTURE</span>{" "}
            <br />
            TOGETHER
          </div>
          <p>Book a free consultation{">"}</p>
        </div> */}
      </Container>
      
              <ContactUsFooter />
              <br />
              <Footer />
              </div>
    );
  }
}
